export default "__VITE_ASSET__B7g1p_Tw__"